import { memo, useCallback } from 'react'

/**
 * ArrangementControls component
 * Provides controls for reordering and deleting guitar arrangements
 */

interface ArrangementControlsProps {
  id: string;
  onMoveUp?: (id: string) => void;
  onMoveDown?: (id: string) => void;
  onDelete?: (id: string) => void;
}

export function ArrangementControls({ 
  id, 
  onMoveUp, 
  onMoveDown, 
  onDelete 
}: ArrangementControlsProps) {
  const handleMoveUp = useCallback(() => {
    onMoveUp?.(id);
  }, [id, onMoveUp]);

  const handleMoveDown = useCallback(() => {
    onMoveDown?.(id);
  }, [id, onMoveDown]);

  const handleDelete = useCallback(() => {
    onDelete?.(id);
  }, [id, onDelete]);

  return (
    <div className="arrangement-controls">
      <div className="button-group-vertical">
        <button 
          type="button" 
          onClick={handleMoveUp}
          className="arrangement-button neon-blue"
          aria-label="Move Up"
          title="Move Up"
        >
          ↑
        </button>
        
        <button 
          type="button" 
          onClick={handleDelete}
          className="arrangement-button delete-button"
          aria-label="Delete"
          title="Delete"
        >
          ×
        </button>

        <button 
          type="button" 
          onClick={handleMoveDown}
          className="arrangement-button neon-blue"
          aria-label="Move Down"
          title="Move Down"
        >
          ↓
        </button>
      </div>
    </div>
  );
}

// Memoize ArrangementControls for performance optimization
export default memo(ArrangementControls);
